module.exports = __webpack_public_path__ + "img/teaser_005.84f57c09.jpeg";